import { AbstractControl } from '@angular/forms';

/**
 * Checks if a form control has a specific validation error and has been touched.
 * Used for LVR-Error.
 * @param control The form control to check.
 * @param errors The name errors to look for.
 * @returns True if any error exists and the control was touched.
 */
export const hasError = (control: AbstractControl | null, ...errors: string[]) => {
	if (!control) return false;

	return errors.some(
		(error) => control.hasError(error) && (control.dirty || !!control.value?.length || control.touched),
	);
};

/**
 * Returns the first matching validation error key of a form control
 * if the control has been interacted with.
 * Used for file-specific validation errors.
 * @param control The form control to check.
 * @param errors The name of the errors to look for.
 * @returns The first matching error key if present; otherwise an empty string.
 */
export const hasFileError = (control: AbstractControl | null, ...errors: string[]) => {
	if (!control) return '';

	const error = errors.find(
		(err) => control.hasError(err) && (control.dirty || !!control.value?.length || control.touched),
	);

	return error ?? '';
};
